import { MicronautStarterSDK } from '../../micronaut'

export const StarterSDK = MicronautStarterSDK
